// Global function to show no products message inline instead of redirecting
window.showNoProductsMessage = function() {
  var noProductsEl = document.getElementById('no-products-inline-message');
  var productGrid = document.getElementById('ProductGridContainer');
  var searchProductList = document.querySelector('.search-product-list');
  var searchHeading = document.querySelector('.search-heading-parent');
  var dynamicFilter = document.querySelector('.product-dynamic-filter-row');
  var pagination = document.querySelector('.paginationfromyearapi');
  
  if (noProductsEl && productGrid) {
    // Hide other content
    if (searchProductList) searchProductList.style.display = 'none';
    if (searchHeading) searchHeading.style.display = 'none';
    if (dynamicFilter) dynamicFilter.style.display = 'none';
    if (pagination) pagination.style.display = 'none';
    
    // Hide all pagination elements
    var allPaginations = document.querySelectorAll('.paginationfromyearapi, .pagination, .paginate');
    allPaginations.forEach(function(el) { el.style.display = 'none'; });
    
    // Show no products message
    noProductsEl.style.display = 'block';
    productGrid.style.display = 'block';
    
    // Hide loader
    var loader = document.querySelector('.brator-cart-item-list-overlay');
    if (loader) loader.classList.remove('open');
    
    // Scroll to no products message
    document.getElementById('no-products-inline-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

// Function to reset/hide the no products message
window.hideNoProductsMessage = function() {
  var noProductsEl = document.getElementById('no-products-inline-message');
  var searchProductList = document.querySelector('.search-product-list');
  var searchHeading = document.querySelector('.search-heading-parent');
  var dynamicFilter = document.querySelector('.product-dynamic-filter-row');
  
  if (noProductsEl) {
    noProductsEl.style.display = 'none';
    if (searchProductList) searchProductList.style.display = '';
    if (searchHeading) searchHeading.style.display = '';
    if (dynamicFilter) dynamicFilter.style.display = '';
    
    // Show pagination again
    var allPaginations = document.querySelectorAll('.paginationfromyearapi, .pagination, .paginate');
    allPaginations.forEach(function(el) { el.style.display = ''; });
  }
};

// Hide loader when navigating back to the page
window.addEventListener('pageshow', function(event) {
  // event.persisted is true when page is loaded from bfcache (back/forward)
  if (event.persisted) {
    var loader = document.querySelector('.brator-cart-item-list-overlay');
    if (loader) {
      loader.classList.remove('open');
      loader.classList.remove('show-loader');
    }
    // Also hide ProductGridContainer if it was in loading state
    var productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      productGrid.style.display = 'none';
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var filterContainer = document.getElementById('classic-search-container');
  if (!filterContainer) return;
  
  var filterBox = filterContainer.closest('.search-filter-box');
  if (!filterBox || !filterBox.dataset.template || !filterBox.dataset.template.startsWith('step_new_')) return;
  
  // Create placeholder element
  var placeholder = document.createElement('div');
  placeholder.className = 'filter-placeholder';
  filterContainer.parentNode.insertBefore(placeholder, filterContainer);
  
  var filterHeight = filterContainer.offsetHeight;
  var filterTop = filterContainer.getBoundingClientRect().top + window.scrollY;
  var headerHeight = 130;
  var minDesktopWidth = 1280; // Only enable sticky on desktop

  function handleScroll() {
    // Disable sticky on mobile/tablet
    if (window.innerWidth < minDesktopWidth) {
      if (filterContainer.classList.contains('is-sticky')) {
        filterContainer.classList.remove('is-sticky');
        placeholder.classList.remove('show');
      }
      return;
    }
    
    var scrollY = window.scrollY;
    var triggerPoint = filterTop - headerHeight;
    
    if (scrollY >= triggerPoint) {
      if (!filterContainer.classList.contains('is-sticky')) {
        filterContainer.classList.add('is-sticky');
        placeholder.style.height = filterHeight + 'px';
        placeholder.classList.add('show');
      }
    } else {
      if (filterContainer.classList.contains('is-sticky')) {
        filterContainer.classList.remove('is-sticky');
        placeholder.classList.remove('show');
      }
    }
  }
  
  // Recalculate on resize
  window.addEventListener('resize', function() {
    filterHeight = filterContainer.offsetHeight;
    filterTop = placeholder.getBoundingClientRect().top + window.scrollY;
    placeholder.style.height = filterHeight + 'px';
    handleScroll(); // Re-check sticky state on resize
  });
  
  window.addEventListener('scroll', handleScroll);
  handleScroll(); // Initial check
});
